<template>
  <div class="passo2">
    <div class="container wp-box section section-artigo with-box">
      <h2>Soluções para você</h2>

      <div class="timeline">
        <div id="timeline-wrap">
          <div id="timeline"></div>
          <div class="marker mfirst timeline-icon one active">1</div>
          <div class="marker m2 timeline-icon two active">2</div>
          <div class="marker m3 timeline-icon three">3</div>
          <div class="marker m4 timeline-icon four">4</div>
          <div class="marker m5 timeline-icon five">5</div>
          <div class="marker mlast timeline-icon six">6</div>
        </div>
      </div>
    </div>


    <div class="container wp-box section section-artigo with-box">
      <div class="row">
        <div class="colsm-12">
          <p>Também precisamos de alguns dados sobre sua renda. Fique tranquilo, os dados são sigilosos e ajudarão a Caixa a definir soluções de crédito adequadas para você.</p>
        </div>
      </div>
      
      
      
      <div class="form-passos">
        <div class="row">
          <div class="colsm-4">
            <div class="control-item">
              <label class="label-d">Seu salário mensal é de (R$):</label>
              <money v-model.lazy="salario" :value="salario" name="salario" class="field-d" v-bind="money" ></money>
              <small class="form-text text-muted">{{ errors.first('salario') }} </small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="colsm-3">
            <div class="control-item">
              <label class="label-d">Recebe seu salário na Caixa?</label>
              <input type="radio" name="recebe-caixa" v-model="recebeCaixa" value="true" class="font-icon" checked="checked"><span class="opcao-radio">Sim</span> 
              <input type="radio" name="recebe-caixa" v-model="recebeCaixa" value="false" class="font-icon"><span class="opcao-radio">Não</span>
            </div>
          </div>
          <div class="colsm-1"></div>
          <div class="colsm-5" v-if="recebeCaixa == 'false'">
            <div class="control-item">
              <label class="label-d">Gostaria de receber seu salário na Caixa e ter taxas melhores?</label>
              <input type="radio" name="receber-caixa" value="true" v-model="gostariaReceber" class="font-icon" checked="checked"><span class="opcao-radio">Sim</span> 
              <input type="radio" name="receber-caixa" value="false" v-model="gostariaReceber" class="font-icon"><span class="opcao-radio">Não</span>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="colsm-4">
            <div class="control-item">
              <label class="label-d">E está precisando de um crédito no valor de (R$):</label>
              <money name="valorEmprestimo" :value="valorEmprestimo" v-model="valorEmprestimo" class="field-d" v-bind="money" placeholder="0,00" v-validate="'required'"></money>
              <small class="form-text text-muted">{{ errors.first('valorEmprestimo') }}</small>
              <small class="form-text text-muted" v-if="erroValor">Informe valor maior que zero.</small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="colsm-8">
            <small class="form-text text-muted" v-if="erroApi">Erro de comunicação com o servidor. Tente novamente mais tarde.</small>
          </div>
        </div>

        <div class="row">
          <div class="colsm-8">
            <a class="btn blue" @click="validarAvancar(dados)">Próxima Etapa</a> <span class="etapa-anterior">ou <router-link :to="{name: 'passo-um', params: {dados}}" >volte à etapa anterior</router-link></span>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>


<script>
import {Money} from 'v-money'
import axios from 'axios';

export default {
  components: {Money},
  name: 'passo2',
  data: function() {
    return {
      salario:0,
      valorEmprestimo: 0,
      recebeCaixa: null,
      gostariaReceber: null,
      erroApi: false,
      dados: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      urlApi: process.env.VUE_APP_URL_API,
      erroValor: false
    };
  },
  methods: {
    validarAvancar(dados) {
      var _this = this;
      _this.dados.mSalario_Mensal = this.salario;
      _this.dados.mNecessidade_Valor = this.valorEmprestimo;
      _this.dados.bTem_Salario_CAIXA = this.recebeCaixa;
      _this.dados.bTraria_Salario_para_CAIXA = this.gostariaReceber;
      
      _this.dados.iPasso_Simulador = 2;

      if(_this.dados.mNecessidade_Valor <= 0){
        _this.erroValor = true;
      }

      _this.$validator.validate().then(valid => {
        if (valid && _this.dados.iID_Visita && !_this.erroValor) {
          this.$loading(true);
          axios.post(_this.urlApi + 'Visita_Dados_PF/' + _this.dados.iID_Visita, _this.dados)
            .then(function (response) {

              try{
                dataLayer.push({
                  'passoSimulador': 'Passo2',
                  'recebeCaixa': _this.recebeCaixa,
                  'querReceberCaixa': _this.gostariaReceber,
                  'event': 'proximoPasso',
                  'tipo': 'PF'
                });
              } catch(error){
                console.error(error);
              }

              _this.$router.push({name:'passo-tres', params:{dados}});
              
              _this.$loading(false);
            })
            .catch(function (error) {
              _this.erroApi = true;
              _this.$loading(false);
            });
        }
      })


    }
  },
  created: function(){
    this.dados = this.$route.params.dados;

    this.salario = this.dados.mSalario_Mensal;
    this.valorEmprestimo = this.dados.mNecessidade_Valor
    this.recebeCaixa = this.dados.bTem_Salario_CAIXA;
    this.gostariaReceber = this.dados.bTraria_Salario_para_CAIXA

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>